var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'OrganizationHome'
      }
    }
  }, [_vm._v(" 組織資料設定 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'ModuleList'
      }
    }
  }, [_vm._v(" 模組管理 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "模組編輯" : _vm.isShow ? "查看模組" : "新增模組") + " ")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.isEdit ? "\u3010".concat(_vm.organizationName, "\u3011\u6A21\u7D44\u7DE8\u8F2F") : _vm.isShow ? "\u3010".concat(_vm.organizationName, "\u3011\u67E5\u770B\u6A21\u7D44") : "\u3010".concat(_vm.organizationName, "\u3011\u65B0\u589E\u6A21\u7D44")) + " "), _vm.isEdit ? _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "variant": "inverse-info"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'ModuleConfig'
        });
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-settings"
  }), _vm._v(" 模組設定 ")]) : _vm._e()], 1)])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('section', {
    staticClass: "row mb-8"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "模組名稱",
      "label-for": "module_name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "module_name",
      "type": "text",
      "readonly": "",
      "placeholder": "（無需輸入，系統將自動帶入）"
    },
    model: {
      value: _vm.state.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "name", $$v);
      },
      expression: "state.form.name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "模組代號",
      "label-for": "module_code"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "module_code",
      "type": "text",
      "state": _vm.v$.form.module_code.$error ? false : null,
      "readonly": _vm.isShow || _vm.isEdit
    },
    model: {
      value: _vm.state.form.module_code,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "module_code", $$v);
      },
      expression: "state.form.module_code"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.module_code.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "通路",
      "label-for": "merchant"
    }
  }, [_vm.isEdit || _vm.isShow ? _c('b-form-input', {
    attrs: {
      "value": _vm.merchantDisplayName,
      "readonly": ""
    }
  }) : _c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.isFetchMerchants
    },
    model: {
      value: _vm.state.form.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "merchant_id", $$v);
      },
      expression: "state.form.merchant_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "模組設定",
      "label-for": "module_config"
    }
  }, [_c('editor', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "module_config",
      "disabled": _vm.isShow,
      "width": "100%",
      "height": "200px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.state.form.module_config,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "module_config", $$v);
      },
      expression: "state.form.module_config"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.module_config.$error
    }
  }, [_vm._v(" 請檢查此欄位資料是否為正確JSON格式 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否啟用",
      "label-for": "is_enabled"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "is_enabled",
      "name": "is_enabled",
      "value": 1,
      "unchecked-value": 0,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.state.form.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.state.form, "is_enabled", $$v);
      },
      expression: "state.form.is_enabled"
    }
  })], 1)], 1)])]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_vm.isShow ? _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("返回 ")])], 1) : _vm._e(), !_vm.isShow ? _c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取消")]) : _vm._e(), _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isSubmmiting,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_vm.isEdit ? _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.handleSubmit(false);
      }
    }
  }, [_vm._v(" 儲存 ")]) : _vm._e(), !_vm.isShow ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "儲存後關閉" : "確認新增") + " ")]) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }